"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_set_1 = require("../data-set");
data_set_1.DataSet.registerTransform('reverse', function (dataView) {
    dataView.rows.reverse();
});
